import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useProjectUIContext } from "../ProjectUIContext";
import { initialFilter } from "../ProjectUIHelpers";
import { getProgramAll } from "../../../MasterData/_redux/program/programCrud";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const prepareFilter = (queryParams, values) => {
  const { name, description, program_uuid } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.description = description ?? "";
  filter.program_uuid = program_uuid ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const ProjectFilter = ({ listLoading }) => {
  // Project UI Context
  const projectUIContext = useProjectUIContext();
  const projectUIProps = useMemo(() => {
    return {
      setQueryParams: projectUIContext.setQueryParams,
      queryParams: projectUIContext.queryParams,
      filterType: projectUIContext.filterType,
    };
  }, [projectUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(projectUIProps.queryParams, values);
    if (!isEqual(newQueryParams, projectUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      projectUIProps.setQueryParams(newQueryParams);
    }
  };

  const [options, setOptions] = useState({
    program: [],
  });

  useEffect(() => {
    getProgramAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        program: res.data.data,
      }))
    );
  }, []);

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  clearTimeout();
                  setFieldValue("name", e.target.value);
                  setTimeout(() => {
                    handleSubmit();
                  }, 500);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Name
              </small>
            </div>
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                name="description"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.description}
                onChange={(e) => {
                  clearTimeout();
                  setFieldValue("description", e.target.value);
                  setTimeout(() => {
                    handleSubmit();
                  }, 500);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Name
              </small>
            </div>
            <div className="col-lg-4">
              <Autocomplete
                name="program_uuid"
                options={options.program}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                  if (value) {
                    setFieldValue("program_uuid", value.uuid);
                    handleSubmit();
                  } else {
                    setFieldValue("program_uuid", "");
                    handleSubmit();
                  }
                }}
                value={
                  options.program.length > 0 &&
                  options.program.find(
                    (option) => option.uuid === values.program_uuid
                  )
                }
                loading={options.program.length === 0 ? true : false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Cari Program"
                    variant="outlined"
                    disableClearable
                    size="small"
                  />
                )}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Name
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
